// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

/** See com.rev360.pms.api.controller.twowaytext.TwoWayTextPatientMatchResponse */
/* istanbul ignore next */
@GandalfModel
export class TwoWayTextPatientMatchResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.Gender)
	@GandalfProperty({ designType: constants.Gender })
	gender!: constants.Gender;

	@GandalfProperty({ designType: PatientNameResponse })
	name!: PatientNameResponse;

	@GandalfProperty({ designType: Number })
	patientId!: number;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	personDateOfBirth!: Date | null;

}
